import React from 'react';
import { Row, Card, Spin } from 'antd';
import logo from '../../images/loginLogo.svg';

interface IProps {
  authState?: any;
}

const Loading: React.FC<IProps> = (props: IProps) => {
  const { authState } = props;

  return authState === 'loading' ? (
    <Row justify="center" align="middle" className="Authenticator-page">
      <Card className="Authenticator-card Authenticator-card-fade-in">
        <img src={logo} alt="ehe-logo" className="Authenticator-logo" />
        <Row justify="center">
          <Spin />
        </Row>
      </Card>
    </Row>
  ) : null;
};

export default Loading;
